
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    totalContactUs:0,
    contactUsListing:[],
    contactUsDetail:null
  };
  
  const contactUsReducer = (state = initialState, action) => {
    console.log("contact us reducers------", state,action);
   switch (action.type) {
     case "ADD_CONTACT_US_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_CONTACT_US_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_CONTACT_US_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_CONTACT_US_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_CONTACT_US_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_CONTACT_US_REQUEST_SUCCESS":
        return {
          ...state,
          contactUsListing: action.payload,
          totalContactUs:action.total,
          loading:false,
        };

      case "GOT_CONTACT_US_DETAIL":  
      return {
        ...state,
        contactUsDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default contactUsReducer;
  